import NameSpace from '../../common/ns/NameSpace'
import AssetsManager from '../../common/data/AssetsManager'
import DataManager from '../../common/data/DataManager'

class ModalView extends PIXI.Container
{
  // ---------------------------------------------------------------------------------------------------------
	// --	ModalView
	// ---------------------------------------------------------------------------------------------------------

  constructor(){
    super();

    //zIndex
    this.zIndex = 100

    //白ベタ
    this.white = new PIXI.Graphics();
    this.white.beginFill(0xFFFFFF);
    this.white.drawRect(0, 0, 100, 100);
    this.white.endFill();
    this.white.interactive = true
    this.addChild(this.white);

    //コンテナ
    this.container = new PIXI.Container();
    this.addChild(this.container);

    //閉じるボタン
    this.closeBtn = AssetsManager.createSpriteByName('common_close_btn');
    this.closeBtn.anchor.set(0.5, 0.5)
    this.closeBtn.buttonMode = true;
    this.closeBtn.interactive = true;
    this.container.addChild(this.closeBtn);
    this.closeBtn.on('tap', this.onClose.bind(this));
    this.closeBtn.on('click', this.onClose.bind(this));

    //NEXTボタン
    this.nextBtn = AssetsManager.createSpriteByName('panel_next_btn');
    this.nextBtn.buttonMode = true;
    this.nextBtn.interactive = true;
    this.nextBtn.x = 264;
    this.nextBtn.y = 141;
    this.container.addChild(this.nextBtn);
    this.nextBtn.on('tap', this.onNext.bind(this));
    this.nextBtn.on('click', this.onNext.bind(this));

    //リセット
    this.reset();
  }

  reset()
  {
    //非表示
    this.visible = false
    this.alpha = 1

    //白ベタ
    this.white.alpha = 0

    //操作不可
    this.closeBtn.interactive = false
    this.nextBtn.interactive = false
    this.nextBtn.visible = true

    //ベースがある場合は破棄
    if(this.base)
    {
      this.container.removeChild(this.base)
      this.base.destroy()
      this.base = null
    }

    //古いパネルを破棄
    if(this.panel)
    {
      this.container.removeChild(this.panel)
      this.panel.destroy()
      this.panel = null
    }
  }

  show(model)
  {
    //モデルを保持
    this.model = model;
    console.log(this.model)

    //新しいパネルを配置
    this.panel = AssetsManager.createSpriteByName(this.model.id);
    this.panel.anchor.set(0.5, 0.5);
    this.container.addChildAt(this.panel, 0);

    //ベースが必要な場合はベース配置
    if(this.model.base)
    {
      this.base = AssetsManager.createSpriteByName(this.model.base);
      this.base.anchor.set(0.5, 0.5);
      this.container.addChildAt(this.base, 0);
    }

    //次へボタンが必要ない時は非表示
    this.nextBtn.visible = this.model.next

    //閉じるボタンの位置
    this.closeBtn.x = this.panel.width/2 - 80
    this.closeBtn.y = -this.panel.height/2 + 80

    //初期表示
    this.container.scale.set(0.9, 0.9);
    this.container.alpha = 0;
    this.visible = true;

    //白ベタ
    TweenMax.killTweensOf(this.white);
    TweenMax.to(this.white, 0.1, {alpha:0.7, ease:'none'});

    //アニメーション
    TweenMax.killTweensOf(this.container);
    TweenMax.killTweensOf(this.container.scale);
    TweenMax.to(this.container, 0.2, {
      alpha :1,
      ease  :'none',
      delay :0.1
    });
    TweenMax.to(this.container.scale, 0.6, {
      x     :1,
      y     :1,
      ease  :'back.out(1.7)',
      delay :0.1,
      onComplete:()=>{
        this.closeBtn.interactive = true;
        this.nextBtn.interactive = true;
        if(this.model.sound != "") AssetsManager.playSound('map', this.model.sound);
      }
    });
  }

  hide()
  {
    //操作不可
    this.closeBtn.interactive = false;
    this.nextBtn.interactive = false;

    //フェードアウト
    TweenMax.killTweensOf(this);
    TweenMax.to(this, 0.2, {alpha:0, ease:'none', onComplete:this.reset.bind(this)});
  }

  // ---------------------------------------------------------------------------------------------------------
	// --	入力
  // ---------------------------------------------------------------------------------------------------------

  onClose()
  {
    //ナレーション停止
    if(this.model.sound != "") AssetsManager.stopSound('map', this.model.sound);

    //イベント発行
    this.emit('MODAL_CLOSE');
  }

  onNext()
  {
    //ナレーション停止
    if(this.model.sound != "") AssetsManager.stopSound('map', this.model.sound);

    //イベント発行
    this.emit('MODAL_NEXT');
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ
	// ---------------------------------------------------------------------------------------------------------
  
  /**
   * リサイズ
   */
  resize()
  {
    const app = DataManager.getData('app');
    const screenW = app.renderer.width;
    const screenH = app.renderer.height;

    this.x = screenW/2;
    this.y = screenH/2;

    this.white.width = screenW;
    this.white.height = screenH;
    this.white.x = -screenW/2;
    this.white.y = -screenH/2;
  }


	// ---------------------------------------------------------------------------------------------------------
}

export default ModalView